import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import PopupSelect from '../mypage/popup_select/PopupSelect';
import PopupOptions from '../mypage/popup_select/popup_select_component/PopupOptions';
import 'slick-carousel'
import 'magnific-popup'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'

class BasicInformationEditor extends React.Component {
  render() {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return (
      <ViewMode
        member={this.props.member}
        prefectures={this.props.prefectures}
        member_areas={this.props.member_areas}
        member_business_types={this.props.member_business_types}
        errors={this.props.errors}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
        update_login_information_url={this.props.update_login_information_url}
      />
    );
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();
    // メッセージエリアをクリア
    const message_area = document.querySelector('div.message_area');
    while (message_area.firstChild) {
      message_area.removeChild(message_area.firstChild);
    }
    const member_business_types_errors = [];
    for (var i in this.props.member_business_types) {
      member_business_types_errors.push({ business_type_length: '', business_type_detail: '' });
    }
    // 編集モードに遷移
    ReactDOM.render(
      <EditMode
        member={this.props.member}
        prefectures={this.props.prefectures}
        member_areas={this.props.member_areas}
        member_business_types={this.props.member_business_types}
        errors={{
          office_name: '',
          name: '',
          public_email: '',
          email: '',
          telephone_number: '',
          display_postal_code_1: '',
          display_postal_code_2: '',
          prefecture: '',
          city: '',
          address_lines: '',
          display_address: '',
          business_description: '',
          office_division: '',
          office_division_etc: '',
          homepage: ''
        }}
        update_url={this.props.update_url}
        csrf_token={this.props.csrf_token}
        update_login_information_url={this.props.update_login_information_url}
      />,
      document.getElementById('basic_information_area')
    );
  }

  render() {
    function MemberBusinessTypesTag(props) {
      if (props.member_business_types.length === 0) {
        return <td>なし</td>
      } else {
        const member_business_types = props.member_business_types;
        const list = [];
        for (var i in member_business_types) {
          list.push(
            <div key={member_business_types[i].id} className="business_type_item">
              {member_business_types[i].name + '　　' + ((member_business_types[i].length && member_business_types[i].length > 0) ? '経験年数' + member_business_types[i].length + '年' : '経験なし')}
              <p className="font_m fs-88">＜仕事内容＞<br />{member_business_types[i].detail != null && member_business_types[i].detail.trim() ? member_business_types[i].detail : 'なし'}</p>
            </div>
          );
        }
        return (
          <td>
            {list}
          </td>
        );
      }
    }
    function MemberAreasValue(props) {
      const values = props.member_areas.map(r => r.name);
      return (values.length === 0 ? 'なし' : values.join('/'));
    }
    function OfficeDivisionValue(props) {
      if (props.value == 1) {
        return '法人事業所';
      } else if (props.value == 2) {
        return '個人事業所';
      } else if (props.value == 99) {
        return 'その他　' + props.etc;
      } else {
        return '';
      }
    }
    function OpenRangeTag(props) {
      if (props.value == 1) {
        return <span className="release_on fs-75">全体に公開</span>
      } else if (props.value == 3) {
        return <span className="release_off fs-75">公開しない</span>
      } else {
        return <span className="release_off fs-75"></span>
      }
    }
    return (
      <React.Fragment>
        <div className="basic">
          <h3 className="fs-113">基本情報</h3>
          <div className="btn_right mypage_basic edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
          <table className="edit">
            <tbody>
              <tr>
                <th>会社名／事業所名<br className="pc" />（屋号）</th>
                <td>{this.props.member.office_name}</td>
              </tr>
              <tr>
                <th>登録者氏名</th>
                <td><p className="mypage_info_area_width">{this.props.member.name}</p><OpenRangeTag value={this.props.member.name_open_range} /></td>
              </tr>
              <tr>
                <th>メールアドレス</th>
                <td><p className="mypage_info_area_width">{this.props.member.public_email}</p><OpenRangeTag value={this.props.member.public_email_open_range} /></td>
              </tr>
              <tr>
                <th>ログインID</th>
                <td><p className="email_label">{this.props.member.email}</p></td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td><p>{this.props.member.telephone_number}</p><OpenRangeTag value={this.props.member.telephone_number_open_range} /></td>
              </tr>
              <tr>
                <th className="hard-wrap">住所</th>
                <td>
                  <p className="mypage_info_area_width">
                    {this.props.member.display_postal_code_1 ? '〒' + this.props.member.display_postal_code_1 + '-' + this.props.member.display_postal_code_2 : ''}<br />
                    {this.props.member.display_address}
                  </p>
                  <OpenRangeTag value={this.props.member.display_address_open_range} />
                </td>
              </tr>
              <tr>
                <th>業種・職種</th>
                <MemberBusinessTypesTag member_business_types={this.props.member_business_types} />
              </tr>
              <tr>
                <th>事業内容</th>
                <td className='label_textarea'>{this.props.member.business_description}</td>
              </tr>
              <tr>
                <th>対応可能エリア</th>
                <td><MemberAreasValue member_areas={this.props.member_areas} /></td>
              </tr>
              <tr>
                <th>事業所区分</th>
                <td><OfficeDivisionValue value={this.props.member.office_division} etc={this.props.member.office_division_etc} /></td>
              </tr>
              <tr>
                <th>ホームページ</th>
                <td><a href={this.props.member.homepage} target="_blank" rel="noopener noreferrer">{this.props.member.homepage}</a></td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">基本情報</h4>
          <div className="btn_right_bottom edit"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>編集する</a></div>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = {
      member: JSON.parse(JSON.stringify(this.props.member)),
      member_areas: JSON.parse(JSON.stringify(this.props.member_areas)),
      member_business_types: JSON.parse(JSON.stringify(this.props.member_business_types)),
      errors: JSON.parse(JSON.stringify(this.props.errors))
    };
    const telephone_number = this.state.member.telephone_number.split('-');
    this.state.member.telephone_number_1 = telephone_number[0];
    this.state.member.telephone_number_2 = telephone_number[1];
    this.state.member.telephone_number_3 = telephone_number[2];
    this.selectedBusinessTypes = React.createRef();
    this.selectedAreas = React.createRef();
    this.handleClick = this.handleClick.bind(this);
    this.handleClickMemberBusinessTypes = this.handleClickMemberBusinessTypes.bind(this);
    this.handleClickMemberAreas = this.handleClickMemberAreas.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelectedBusinessTypes = this.handleChangeSelectedBusinessTypes.bind(this);
    this.handleChangeSelectedAreas = this.handleChangeSelectedAreas.bind(this);
    this.handleChangeBusinessTypeDetails = this.handleChangeBusinessTypeDetails.bind(this);
  }

  componentDidMount() {
    this.$selectedBusinessTypes = $(this.selectedBusinessTypes);
    this.$selectedBusinessTypes.on('change', this.handleChangeSelectedBusinessTypes);
    this.$selectedAreas = $(this.selectedAreas);
    this.$selectedAreas.on('change', this.handleChangeSelectedAreas);
  }

  componentWillUnmount() {
    this.$selectedBusinessTypes.off('change', this.handleChangeSelectedBusinessTypes);
    this.$selectedAreas.off('change', this.handleChangeSelectedAreas);
  }

  handleClick(e) {
    // デフォルト動作の解除
    e.preventDefault();

    // 「プロフィール公開範囲」の設定
    let profile_open_range = 3; // 3:「公開しない」
    if (this.state.member.display_address_open_range == 1 || this.state.member.telephone_number_open_range == 1 || this.state.member.public_email_open_range == 1) {
      profile_open_range = 1;   // 1:「全体に公開」
    }
    // ボタン非活性
    let elements = document.querySelectorAll('.btn_target');
    elements.forEach(function (element) {
      element.classList.add('btn_disabled');
    });
    // membersの更新
    fetch(this.props.update_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        associate_member: {
          office_name: this.state.member.office_name,
          name: this.state.member.name,
          name_open_range: this.state.member.name_open_range,
          public_email: this.state.member.public_email,
          public_email_open_range: this.state.member.public_email_open_range,
          email: this.state.member.email,
          telephone_number: this.state.member.telephone_number,
          telephone_number_open_range: this.state.member.telephone_number_open_range,
          display_postal_code_1: this.state.member.display_postal_code_1,
          display_postal_code_2: this.state.member.display_postal_code_2,
          prefecture: this.state.member.prefecture,
          city: this.state.member.city,
          address_lines: this.state.member.address_lines,
          display_address: this.state.member.display_address,
          display_address_open_range: this.state.member.display_address_open_range,
          business_description: this.state.member.business_description,
          office_division: this.state.member.office_division,
          office_division_etc: this.state.member.office_division_etc,
          homepage: this.state.member.homepage,
          profile_open_range: profile_open_range
        },
        member_areas: this.state.member_areas,
        member_business_types: this.state.member_business_types,
        authenticity_token: this.props.csrf_token
      })
    }).then((res) => {
      return res.json();
    }).then((data) => {
      // メッセージエリアをクリア
      const message_area = document.querySelector('div.message_area');
      while (message_area.firstChild) {
        message_area.removeChild(message_area.firstChild);
      }
      if (data.status == 200) {
        const member_business_types = [];
        for (var i in this.state.member_business_types) {
          member_business_types.push({
            id: this.state.member_business_types[i].id,
            name: this.state.member_business_types[i].name,
            length: this.state.member_business_types[i].length,
            detail: this.state.member_business_types[i].detail,
            length_error: '',
            detail_error: '',
            public_email_error: ''
          })
        }
        // ViewModeを再表示
        ReactDOM.render(
          <ViewMode
            member={this.state.member}
            prefectures={this.props.prefectures}
            member_areas={this.state.member_areas}
            member_business_types={member_business_types}
            errors={this.props.errors}
            update_url={this.props.update_url}
            csrf_token={this.props.csrf_token}
            update_login_information_url={this.props.update_login_information_url}
          />,
          document.getElementById('basic_information_area')
        );
        // 変更された項目があるとき
        if (Object.keys(data.saved_changes).length !== 0) {
          // 更新メッセージ表示
          const node = document.createElement('p');
          const message = document.createTextNode('プロフィールを更新しました。');
          node.appendChild(message);
          document.querySelector('div.message_area').appendChild(node);
          // ページ上部の「業種」「活動地域」を更新
          const content1 = this.state.member_business_types.map(r => r.name).join('/');
          const content2 = this.state.member_areas.map(r => r.name).join('/');
          if (content1.length === 0) { content1 = 'なし' }
          if (content2.length === 0) { content2 = 'なし' }
          $('#mypage_area dl.industry_list dd#business_types').text(content1);
          $('#mypage_area dl.industry_list dd#areas').text(content2);
        }
      } else if (data.status == 400) {
        // 状態を更新
        this.setState({ member_business_types: data.member_business_types, errors: data.errors });
        // エラーメッセージ表示
        const node = document.createElement('p');
        const message = document.createTextNode('入力内容にエラーがあります。');
        node.appendChild(message);
        document.querySelector('div.message_area').appendChild(node);
      }
      // ボタン活性
      let elements = document.querySelectorAll('.btn_target');
      elements.forEach(function (element) {
        element.classList.remove('btn_disabled');
      });
    }).catch((err) => {
      console.error(err);
    });
  }

  // 活動地域
  async handleClickMemberAreas(e) {
    e.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_areas';
      const data = { selected_ids: this.state.member_areas.map(r => r.id) };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedAreas) => {
      this.setState({ member_areas: selectedAreas });
      $(this.selectedAreas).val(selectedAreas);
    };

    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-area-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.areas}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={true}
        rootNode={rootNode}
      />, rootNode
    );
  }

  // 業種・職種
  async handleClickMemberBusinessTypes(event) {
    event.preventDefault();

    const url = (() => {
      // URLを作成する
      const path = '/popup/member_business_types';
      const data = {
        selected_ids: this.state.member_business_types.map(r => r.id),
        is_limited_item: 1
      };
      return path + '?' + (new URLSearchParams(data)).toString();
    })();

    const data = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      return response.json();
    }).then(result => {
      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error("status is not 200");
      }
    }).catch(error => {
      console.error(new Error(error.message));
      alert('項目の取得中にエラーが発生しました。');
    });

    const onClosePopup = (selectedBusinessTypes) => {
      // 業種・職種の詳細情報{経験年数: length, 仕事内容: detail}が
      // ユーザ入力時に新要素としてmember_business_typesに追加される
      // set時にselectedBusinessTypesに上記要素を追加する必要がある
      for (let selectedBType of selectedBusinessTypes) {
        for (let prevBType of this.state.member_business_types) {
          if (selectedBType.id === prevBType.id) {
            selectedBType.length = prevBType.length || "";
            selectedBType.detail = prevBType.detail || "";
          }
        }
      }

      this.setState({ member_business_types: selectedBusinessTypes });
      $(this.selectedBusinessTypes).val(selectedBusinessTypes);
    };

    const rootNode = document.querySelector('#popup_industry');
    const ButtonArea = props => {
      return <a className="select select-industry-btn" onClick={props.onClickCloseButton}>選択</a>
    };
    ReactDOM.render(
      <PopupSelect
        popupOptions={PopupOptions.businessTypes}
        sectionTypes={data.sectionTypes}
        itemTypes={data.itemTypes}
        isLimitedItem={data.isLimitedItem}
        selectedIds={data.selectedIds.map(Number)}
        onClosePopup={onClosePopup}
        ButtonArea={ButtonArea}
        needSelectedAllButton={false}
        rootNode={rootNode}
      />, rootNode
    );
  }

  handleChange(e) {
    const member = this.state.member;
    switch (e.target.id) {
      case 'office_name':
        member.office_name = e.target.value;
        break;
      case 'name':
        member.name = e.target.value;
        break;
      case 'name_open_range':
        member.name_open_range = e.target.value;
        break;
      case 'public_email':
        member.public_email = e.target.value;
        break;
      case 'public_email_open_range':
        member.public_email_open_range = e.target.value;
        break;
      case 'telephone_number_1':
        member.telephone_number_1 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_2':
        member.telephone_number_2 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_3':
        member.telephone_number_3 = e.target.value;
        member.telephone_number = member.telephone_number_1 + '-' + member.telephone_number_2 + '-' + member.telephone_number_3;
        break;
      case 'telephone_number_open_range':
        member.telephone_number_open_range = e.target.value
        break;
      case 'display_postal_code_1':
        member.display_postal_code_1 = e.target.value;
        break;
      case 'display_postal_code_2':
        member.display_postal_code_2 = e.target.value;
        break;
      case 'prefecture':
        member.prefecture = e.target.value;
        member.display_address = member.prefecture + member.city + member.address_lines;
        break;
      case 'city':
        member.city = e.target.value;
        member.display_address = member.prefecture + member.city + member.address_lines;
        break;
      case 'address_lines':
        member.address_lines = e.target.value;
        member.display_address = member.prefecture + member.city + member.address_lines;
        break;
      case 'display_address':
        member.display_address = e.target.value;
        break;
      case 'display_address_open_range':
        member.display_address_open_range = e.target.value;
        break;
      case 'business_description':
        member.business_description = e.target.value;
        break;
      case 'office_division':
        member.office_division = e.target.value;
        if (member.office_division != 99) {
          member.office_division_etc = '';
        }
        break;
      case 'office_division_etc':
        member.office_division_etc = e.target.value;
        break;
      case 'homepage':
        member.homepage = e.target.value;
    }
    // 状態を更新
    this.setState({ member: member });
  }

  handleChangeSelectedAreas(e) {
    const selected_areas_value = '[]';
    if (e.target.value) {
      selected_areas_value = JSON.parse(e.target.value);
    }
    this.setState({ member_areas: selected_areas_value });
  }

  handleChangeSelectedBusinessTypes(e) {
    const selected_business_types_value = '[]';
    if (e.target.value) {
      const member_business_types = this.state.member_business_types;
      selected_business_types_value = JSON.parse(e.target.value);
      for (var i in selected_business_types_value) {
        for (var ii in member_business_types) {
          if (member_business_types[ii].id === selected_business_types_value[i].id) {
            selected_business_types_value[i].length = member_business_types[ii].length;
            selected_business_types_value[i].detail = member_business_types[ii].detail;
            selected_business_types_value[i].length_error = member_business_types[ii].length_error;
            selected_business_types_value[i].detail_error = member_business_types[ii].detail_error;
          }
        }
      }
    }
    this.setState({ member_business_types: selected_business_types_value });
  }

  handleChangeBusinessTypeDetails(e) {
    const member_business_types = this.state.member_business_types;
    if (e.target.id.indexOf('business_type_length') === 0) {
      const business_type_id = parseInt(e.target.id.replace('business_type_length_', ''), 10);
      for (var i in member_business_types) {
        if (member_business_types[i].id === business_type_id) {
          member_business_types[i].length = e.target.value;
        }
      }
    } else if (e.target.id.indexOf('business_type_detail') === 0) {
      const business_type_id = parseInt(e.target.id.replace('business_type_detail_', ''), 10);
      for (var i in member_business_types) {
        if (member_business_types[i].id === business_type_id) {
          member_business_types[i].detail = e.target.value;
        }
      }
    }
    // 状態を更新
    this.setState({ member_business_types: member_business_types });
  }

  render() {
    function ErrorMessageTag(props) {
      if (props.item == '全体' && props.message) {
        return <div className="error_massage none_markup">エラー項目があります。</div>;
      } else if (props.item && props.message) {
        return <div className="error_massage">{props.item}{props.message}</div>;
      } else if (props.message) {
        return <div className="error_massage">{props.message}</div>;
      } else {
        return null;
      }
    }
    const prefecture_select_options = [];
    prefecture_select_options.push(<option key="#" value="">選択してください</option>);
    for (var i in this.props.prefectures) {
      prefecture_select_options.push(<option key={i} value={this.props.prefectures[i]}>{this.props.prefectures[i]}</option>);
    }
    const member_business_type_details = [];
    for (var i in this.state.member_business_types) {
      member_business_type_details.push(
        <div key={this.state.member_business_types[i].id} className="business_type_item">
          {this.state.member_business_types[i].name}
          <ErrorMessageTag item={'業種・職種 経験年数'} message={this.state.member_business_types[i].length_error} />
          <p className="font_m fs-88">＜経験年数＞<br />
            <input id={'business_type_length_' + this.state.member_business_types[i].id}
              type="text"
              maxLength="2"
              min="0"
              value={this.state.member_business_types[i].length ? this.state.member_business_types[i].length : ''}
              onChange={this.handleChangeBusinessTypeDetails}
              className="w15"
            />&nbsp;年
          </p>
          <ErrorMessageTag item={'業種・職種 仕事内容'} message={this.state.member_business_types[i].detail_error} />
          <p className="font_m fs-88">＜仕事内容＞<br />
            <input id={'business_type_detail_' + this.state.member_business_types[i].id} type="text" value={this.state.member_business_types[i].detail ? this.state.member_business_types[i].detail : ''} onChange={this.handleChangeBusinessTypeDetails} className="w100" maxLength="100" />
          </p>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div className="basic input_group_area">
          <h3 className="fs-113">基本情報</h3>
          <div className="btn_right mypage_basic"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
          <ErrorMessageTag item={'全体'} message={this.state.errors ? Object.values(this.state.errors).join('') : ''} />
          <table className="basic_information_table edit">
            <tbody>
              <tr>
                <th>会社名／事業所名<br className="pc" />（屋号）<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'会社名／事業所名（屋号）'} message={this.state.errors.office_name} />
                  <input id="office_name" type="text" value={this.state.member.office_name} onChange={this.handleChange} className="w100 completed" maxLength="100" />
                </td>
              </tr>
              <tr>
                <th>登録者氏名<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'登録者氏名'} message={this.state.errors.name} />
                  <input id="name" type="text" value={this.state.member.name} onChange={this.handleChange} className="w50 col1 completed" maxLength="80" />
                  <select id="name_open_range" value={this.state.member.name_open_range} onChange={this.handleChange} className={this.props.member.name_open_range ? "col1 completed" : "col1"}>
                    <option value="1">全体に公開する</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>メールアドレス</th>
                <td>
                  <ErrorMessageTag item={'メールアドレス'} message={this.state.errors.public_email} />
                  <input id="public_email" type="text" maxLength="255" value={this.state.member.public_email} onChange={this.handleChange} className={this.props.member.public_email ? "w50 col1 completed" : "w50 col1"} />
                  <select id="public_email_open_range" value={this.state.member.public_email_open_range} onChange={this.handleChange} className={this.props.member.public_email_open_range ? "col1 completed" : "col1"}>
                    <option value="1">全体に公開する</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>ログインID</th>
                <td>
                  <p className="email_label">{this.props.member.email}</p>
                  <p className="font_m fs-81">※このメールアドレスは公開されません</p>
                  <p className="font_m fs-81 email_notice">※ログインIDの変更は<a href={this.props.update_login_information_url}>「ログイン情報の変更」画面</a>にて行ってください。</p>
                </td>
              </tr>
              <tr>
                <th>電話番号<span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'電話番号'} message={this.state.errors.telephone_number} />
                  <input id="telephone_number_1" type="text" maxLength="5" value={this.state.member.telephone_number_1} onChange={this.handleChange} className="w15 completed telephone" />-
                  <input id="telephone_number_2" type="text" maxLength="4" value={this.state.member.telephone_number_2} onChange={this.handleChange} className="w15 completed telephone2" />-
                  <input id="telephone_number_3" type="text" maxLength="4" value={this.state.member.telephone_number_3} onChange={this.handleChange} className="w15 completed telephone3" />
                  <select id="telephone_number_open_range" value={this.state.member.telephone_number_open_range} onChange={this.handleChange} className={this.props.member.telephone_number_open_range ? "col1 completed" : "col1"}>
                    <option value="1">全体に公開する</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>住所<span className="required">(必須)</span></th>
                <td className="address_td">
                  <ErrorMessageTag item={'郵便番号'} message={this.state.errors.display_postal_code_1 ? this.state.errors.display_postal_code_1 : this.state.errors.display_postal_code_2 ? this.state.errors.display_postal_code_2 : ''} />
                  <span className="span_postal_code">郵便番号</span><br className="sp" />
                  <input id="display_postal_code_1" type="text" maxLength="3" value={this.state.member.display_postal_code_1} onChange={this.handleChange} className="w15 completed postalcode" /> -
                  <input id="display_postal_code_2" type="text" maxLength="4" value={this.state.member.display_postal_code_2} onChange={this.handleChange} className="w15 completed postalcode2" />
                  <select id="display_address_open_range" value={this.state.member.display_address_open_range} onChange={this.handleChange} className={this.props.member.display_address_open_range ? "col1 completed pc" : "col1 pc"}>
                    <option value="1">全体に公開する</option>
                    <option value="3">公開しない</option>
                  </select>
                  <br />
                  <ErrorMessageTag item={'住所'} message={this.state.errors.display_address} />
                  <input id="display_address" type="hidden" value={this.state.member.display_address} onChange={this.handleChange} />
                  <ErrorMessageTag item={'都道府県'} message={this.state.errors.prefecture} />
                  <span className="span_prefectures">都道府県</span>
                  <select id="prefecture" value={this.state.member.prefecture} onChange={this.handleChange} className="select_prefectures completed">
                    {prefecture_select_options}
                  </select><br />
                  <ErrorMessageTag item={'市区町村'} message={this.state.errors.city} />
                  <span className="span_city">市区町村</span>
                  <input id="city" type="text" value={this.state.member.city} onChange={this.handleChange} className="w60 completed city_text" maxLength="50" /><br />
                  <ErrorMessageTag item={'番地/建物名'} message={this.state.errors.address_lines} />
                  <span className="span_address">番地/建物名</span>
                  <input id="address_lines" type="text" value={this.state.member.address_lines} onChange={this.handleChange} className="w60 completed" maxLength="100" />
                  <select id="display_address_open_range" value={this.state.member.display_address_open_range} onChange={this.handleChange} className={this.props.member.display_address_open_range ? "col1 completed sp" : "col1 sp"}>
                    <option value="1">全体に公開する</option>
                    <option value="3">公開しない</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>業種・職種<span className="required">(必須)</span><p className="input_note">※業種・職種は3つまで選択できます</p></th>
                <td>
                  <ErrorMessageTag item={'業種・職種'} message={this.state.errors.member_business_types} />
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberBusinessTypes}>
                    <input id="member_business_types" type="text" className="w100 area completed" value={this.state.member_business_types.length > 0 ? this.state.member_business_types.map(r => r.name).join('/') : ''} placeholder={'業種を選択'} readOnly />
                  </a>
                  <input type="hidden" id="selected_business_types" ref={selectedBusinessTypes => this.selectedBusinessTypes = selectedBusinessTypes} />
                  <div id="member_business_type_details">
                    {member_business_type_details}
                  </div>
                </td>
              </tr>
              <tr>
                <th>事業内容</th>
                <td>
                  <ErrorMessageTag item={'事業内容'} message={this.state.errors.business_description} />
                  <textarea id="business_description" className={this.props.member.business_description ? "input_textarea height150 completed" : "input_textarea height150"} onChange={this.handleChange} defaultValue={this.state.member.business_description} maxLength="100" ></textarea>
                </td>
              </tr>
              <tr>
                <th>対応可能エリア<br className="pc" /><span className="required">(必須)</span></th>
                <td>
                  <ErrorMessageTag item={'対応可能エリア'} message={this.state.errors.member_areas} />
                  <a href="" className="inline_link area" data-id="area" onClick={this.handleClickMemberAreas}>
                    <input type="text" className="w100 area completed" value={this.state.member_areas.map(r => r.name).join('/')} placeholder={'対応可能エリアを選択'} readOnly />
                  </a>
                  <input type="hidden" id="selected_areas" ref={selectedAreas => this.selectedAreas = selectedAreas} />
                </td>
              </tr>
              <tr>
                <th>事業所区分<span className="required">(必須)</span></th>
                <td className="fixex_textbox">
                  <ErrorMessageTag item={'事業所区分（その他）'} message={this.state.errors.office_division_etc} />
                  <select id="office_division" value={this.state.member.office_division} onChange={this.handleChange} className="col2 completed">
                    <option value="1">法人事業所</option>
                    <option value="2">個人事業所</option>
                    <option value="99">その他</option>
                  </select>
                  <input id="office_division_etc" type="text" value={this.state.member.office_division_etc} onChange={this.handleChange} className={this.props.member.office_division_etc ? "w50 col1 completed" : "w50 col1"} disabled={this.state.member.office_division == 99 ? '' : 'disabled'} maxLength="100" />
                </td>
              </tr>
              <tr>
                <th>ホームページ</th>
                <td>
                  <ErrorMessageTag item={'ホームページアドレス'} message={this.state.errors.homepage} />
                  <input id="homepage" type="text" value={this.state.member.homepage} onChange={this.handleChange} className={this.props.member.homepage ? "w100 completed" : "w100"} maxLength="1024" />
                </td>
              </tr>
            </tbody>
          </table>
          <h4 className="fs-113 title_bottom">基本情報</h4>
          <div className="btn_right_bottom"><a href="" className="fs-75 btn_target" onClick={this.handleClick}>更新</a></div>
        </div>
      </React.Fragment>
    );
  }
}

BasicInformationEditor.propTypes = { member: PropTypes.object }

export default BasicInformationEditor
